@if (packageType$ | async; as packageType) {
  <elder-basic-pane-layout class="full p-pane" elderPlugParentForm>
    <elder-pane class="flex outlined">
      <elder-pane-content>
        <elder-pane-subtitle>
          {{ 'labeling.package' | translate }}
        </elder-pane-subtitle>
        <div class="layout-row place-start-center gap-md">
          <mat-checkbox name="labelingEnabled" [(ngModel)]="packageType.labelingSpec.enabled"
            >{{ 'labeling.enabled' | translate }}
          </mat-checkbox>
          <mat-form-field class="flex" subscriptSizing="dynamic">
            <mat-label>{{ 'context.template' | translate }}</mat-label>
            <input
              matInput
              name="packageLabelTemplate"
              placeholder="{{ 'context.template' | translate }}"
              [(ngModel)]="packageType.labelingSpec.template"
            />
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        </div>
      </elder-pane-content>
    </elder-pane>
    <elder-pane class="flex outlined">
      <elder-pane-subtitle class="p-pane">
        {{ 'labeling.packageContent' | translate }}
      </elder-pane-subtitle>
      <elder-table
        class="flex"
        elderDataViewDnd
        (itemDropped)="onItemDropped($event)"
        [canDrag]="true"
        [data]="data"
        [selectionVisible]="true"
        [selectionMultiEnabled]="true"
      >
        <elder-data-toolbar
          *elderTableToolbar
          [canAdd]="true"
          [canRemove]="true"
          [canMore]="false"
          (requestNew)="onAddContentLabelSpec()"
          (requestRemove)="removeContentLabelSpec($event)"
        >
        </elder-data-toolbar>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let spec">
            <mat-form-field subscriptSizing="dynamic" elderDense>
              <input
                matInput
                [name]="'name-value-' + spec.id"
                type="text"
                [required]="true"
                [(ngModel)]="spec.name"
              />
              <mat-error elderValidationError></mat-error>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="template">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.template' | translate }}
          </th>
          <td mat-cell *matCellDef="let spec">
            <mat-form-field class="layout-row" subscriptSizing="dynamic" elderDense>
              <input
                matInput
                [name]="'template-value-' + spec.id"
                type="text"
                [(ngModel)]="spec.template"
              />
            </mat-form-field>
          </td>
        </ng-container>
      </elder-table>
    </elder-pane>
  </elder-basic-pane-layout>
}
